<template>
  <div
    v-if="values.startPostalCode && values.startCity"
    class="summary_section" id="summary_step1"
  >
    <div class="label">
      {{ labels.step1.title + ' ' + labels.step1.subtitle }}
    </div>
    <p v-if="values.startPostalAddress">
      <b>{{ labels.postalAddress }}</b
      ><br />{{ values.startPostalAddress }}
    </p>
    <p>
      <b>{{ labels.postalCode }}</b
      ><br />{{ values.startPostalCode }}
    </p>
    <p>
      <b>{{ labels.city }}</b
      ><br />{{ values.startCity }}
    </p>
    <p v-if="values.startCountry">
      <b>{{ labels.country }}</b
      ><br />{{ values.startCountry }}
    </p>
    <p v-if="values.startFloor">
      <b>{{ labels.floor }}</b
      ><br />{{ values.startFloor }}
    </p>
    <div v-if="values.startAddressFields?.length">
      <p>
        <b>{{ labels.addressFields }}</b
        ><br /><span v-for="value in values.startAddressFields"
          >- {{ value }}<br
        /></span>
      </p>
    </div>
    <div class="info" v-if="values.startInformation">
      <p>
        <b>{{ labels.information }}</b>
      </p>
      <div v-html="formatText(values.startInformation)"></div>
    </div>
    <div class="devis-btn-group">
      <button type="button" class="devis-btn devis-btn--red" @click="goStep(0)">
        {{ __('Edit this step', 'smdt') }}
      </button>
    </div>
  </div>

  <div
      v-if="values.destPostalCode && values.destCity"
      class="summary_section" id="summary_step2"
  >
    <div class="label">
      {{ labels.step2.title + ' ' + labels.step2.subtitle }}
    </div>
    <p v-if="values.destPostalAddress">
      <b>{{ labels.postalAddress }}</b
      ><br />{{ values.destPostalAddress }}
    </p>
    <p>
      <b>{{ labels.postalCode }}</b
      ><br />{{ values.destPostalCode }}
    </p>
    <p>
      <b>{{ labels.city }}</b
      ><br />{{ values.destCity }}
    </p>
    <p v-if="values.destCountry">
      <b>{{ labels.country }}</b
      ><br />{{ values.destCountry }}
    </p>
    <p v-if="values.destFloor">
      <b>{{ labels.floor }}</b
      ><br />{{ values.destFloor }}
    </p>
    <div v-if="values.destAddressFields?.length">
      <p>
        <b>{{ labels.addressFields }}</b
        ><br /><span v-for="value in values.destAddressFields"
      >- {{ value }}<br
      /></span>
      </p>
    </div>


    <div class="info" v-if="values.destInformation">
      <p>
        <b>{{ labels.information }}</b>
      </p>
      <div v-html="formatText(values.destInformation)"></div>
    </div>
    <div class="devis-btn-group">
      <button type="button" class="devis-btn devis-btn--red" @click="goStep(1)">
        {{ __('Edit this step', 'smdt') }}
      </button>
    </div>
  </div>

  <div
      v-if="values.moveDate"
      class="summary_section" id="summary_step3"
  >
    <div class="label">
      {{ labels.step3.title + ' ' + labels.step3.subtitle }}
    </div>
    <p>
      <b>{{ labels.moveDate }}</b
      ><br />{{ values.moveDate }}
    </p>
    <p v-if="values.moveFurniture">
      <b>{{ labels.moveFurniture }}</b
      ><br />{{ values.moveFurniture }} €
    </p>
    <p v-if="values.moveMeter">
      <b>{{ labels.moveMeter }}</b
      ><br />{{ values.moveMeter }}
    </p>
    <div class="devis-btn-group">
      <button type="button" class="devis-btn devis-btn--red" @click="goStep(2)">
        {{ __('Edit this step', 'smdt') }}
      </button>
    </div>
  </div>
  <div class="summary_section" id="summary_step4">
    <div class="label">
      {{ labels.step4.title + ' ' + labels.step4.subtitle }}
    </div>
    <div v-if="!values.moveMeter && values.inventorySum">
      <p><b>{{ __('Estimated volume:', 'smdt') }}</b><br/>
        <span class="summary__count"><span class="summary__count__number">{{ values.inventorySum }}</span> m<sup>3</sup></span>
      </p>

      <div v-if="values.inventoryInformation">
        <p><b>{{ labels.information }}</b></p>
        <div v-html="formatText(values.inventoryInformation)"></div>
      </div>
      <div class="devis-btn-group">
        <button type="button" class="devis-btn devis-btn--red" @click="goStep(3)">
          {{ __('Edit this step', 'smdt') }}
        </button>
      </div>
    </div>
    <div v-if="values.moveMeter">
      <p>{{ __('Skipped because you filled your volume in previous step', 'smdt') }}</p>
    </div>
  </div>
  <div class="summary_section" id="summary_step5">
    <div class="label">
      {{ labels.step5.title + ' ' + labels.step5.subtitle }}
    </div>
    <p><b>{{ __('Chosen prestation:', 'smdt') }}</b><br>{{ values.offerName }}</p>
    <div class="devis-btn-group">
      <button type="button" class="devis-btn devis-btn--red" @click="goStep(4)">
        {{ __('Edit this step', 'smdt') }}
      </button>
    </div>
  </div>
  <div class="summary_section" id="summary_step6">
    <div class="label">
      {{ labels.step6.title + ' ' + labels.step6.subtitle }}
    </div>
    <p>
      <b>{{ labels.contactCivility }}</b
      ><br />{{ values.contactCivility }}
    </p>
    <p>
      <b>{{ labels.contactFirstName }}</b
      ><br />{{ values.contactFirstName }}
    </p>
    <p>
      <b>{{ labels.contactLastName }}</b
      ><br />{{ values.contactLastName }}
    </p>
    <p>
      <b>{{ labels.contactEmail }}</b
      ><br />{{ values.contactEmail }}
    </p>
    <p>
      <b>{{ labels.contactHomePhone }}</b
      ><br />{{ values.contactHomePhone }}
    </p>
    <p v-if="values.contactBusinessPhone">
      <b>{{ labels.contactBusinessPhone }}</b
      ><br />{{ values.contactBusinessPhone }}
    </p>
    <div v-if="values.contactInformation">
      <p><b>{{ labels.information }}</b></p>
      <div v-html="formatText(values.contactInformation)"></div>
    </div>
    <div class="devis-btn-group">
      <button type="button" class="devis-btn devis-btn--red" @click="goStep(5)">
        {{ __('Edit this step', 'smdt') }}
      </button>
    </div>
  </div>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="g-col-12 devis-gdpr"
    style="margin-bottom: 20px;margin-top:20px"
    v-html="apiData.gpdrText"
  ></div>
  <!-- eslint-disable -->
    <div class="g-col-12">
      <div class="devis-btn-group">
        <button
          type="button"
          class="devis-btn devis-btn--white"
          @click="goStep(5)"
        >
          {{ __('Previous step', 'smdt') }}
        </button>
        <button
          type="button"
          class="devis-btn"
          :disabled="!canNext"
          @click="submit"
        >
          {{ __('Send my request', 'smdt') }}
        </button>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

// eslint-disable-next-line no-undef
const themeObject = vnObject

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageSeven',

  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      labels: {
        step1: {
          title: __('Stage 1:', 'smdt'),
          subtitle: __('Start address', 'smdt'),
        },
        step2: {
          title: __('Stage 2:', 'smdt'),
          subtitle: __('Destination address', 'smdt'),
        },
        step3: {
          title: __('Stage 3:', 'smdt'),
          subtitle: __('The move', 'smdt'),
        },
        step4:
        {
          title: __('Stage 4:', 'smdt'),
          subtitle: __('The inventory', 'smdt'),
        },
        step5:
        {
          title: __('Stage 5:', 'smdt'),
          subtitle: __('Choice of prestation', 'smdt'),
        },
        step6: {
          title: __('Stage 6:', 'smdt'),
          subtitle: __('Your contact details', 'smdt'),
        },
        step7: {
          title: __('Stage 7:', 'smdt'),
          subtitle: __('Summary', 'smdt'),
        },
        postalAddress: __('Postal address:', 'smdt'),
        postalCode: __('Postal code:', 'smdt'),
        city: __('City:', 'smdt'),
        country: __('Country:', 'smdt'),
        floor: __('Floor:', 'smdt'),
        addressFields: __('Ease of access:', 'smdt'),
        information: __('Further informations:', 'smdt'),
        moveDate : __('Desired moving period:', 'smdt'),
        moveFurniture : __('Value of furniture to be moved:', 'smdt'),
        moveMeter: __('Volume in m³:', 'smdt'),
        contactCivility: __('Civility:', 'smdt'),
        contactFirstName: __('First name:', 'smdt'),
        contactLastName: __('Last name:', 'smdt'),
        contactEmail: __('Email:', 'smdt'),
        contactHomePhone: __('Home phone:', 'smdt'),
        contactBusinessPhone: __('Business phone:', 'smdt'),
      },
    }
  },
  computed: {
    ...mapWritableState(useStagesStore, ['stages', 'values', 'ajaxLoading']),
    ...mapState(useStagesStore, ['apiData', 'inventories', 'canNext']),
    canSubmit() {
      if (!this.values.startPostalCode || !this.values.startCity) {
        return 1
      }

      if (!this.values.destPostalCode || !this.values.destCity) {
        return 2
      }

      if (!this.values.moveDate) {
        return 3
      }

      const sum = this.inventories.reduce((acc, cur) => {
        return acc + cur.size * 1 * cur.count
      }, 0)

      if (!sum > 0 && !this.values.moveMeter) {
        return 4
      }

      if (!this.values.offer) {
        return 5
      }

      return true
    },
  },
  mounted() {
    this.setValid(true)
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid', 'goStep', 'reset']),
    __,
    formatText(text) {
      // Remplacez les sauts de ligne par des balises <p>
      const lines = text.split('\n');
      const formattedText = lines.map(line => `<p style="margin-bottom: 10px;">${line}</p>`).join('');
      return formattedText;
    },
    submit() {
      if (this.canSubmit !== true) {
        this.currentStage = this.canSubmit
        return
      }

      $.ajax({
        url: themeObject.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          action: 'vn_devis',
          values: this.values,
          _ajax_nonce: themeObject.nonce,
        },
        beforeSend: () => {
          this.ajaxLoading = true
        },
        success: (res) => {
          if (res.success) {
            this.reset()

            if (res.data.redirect) {
              window.location.href = res.data.redirect
            } else {
              this.$swal({
                icon: 'success',
                title: __('Your request was sent!', 'smdt'),
                text: __(
                  'We have received your request. We also sent you a copy by email.',
                  'smdt'
                ),
              })
            }
          } else {
            this.$swal({
              icon: 'error',
              title: __('Oops...', 'smdt'),
              text: __('Something went wrong! Please try again later.', 'smdt'),
            })
          }
        },
        complete: () => {
          this.ajaxLoading = false
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.summary_section {
  padding: 30px;
  background-color: #fff;
  margin-bottom: 10px;

  .label {
    font-size: 16px;
    margin-bottom: 20px;
    color: var(--vn-secondary-color);
    font-weight: bold;
  }

  p {
    margin-bottom: 10px;
  }

  p.w-100 {
    width: 100%;
  }

  @include media-breakpoint-up(lg) {
    p:not(.w-100) {
      width: 50%;
      display: inline-block;
    }
  }

  .devis-btn-group {
    margin-top: 20px;
  }

  .info {
    p {
      width: 100%;
    }
  }
  .summary__count {
    display: block;
    margin: 0 0 5px;
    font-size: 16px;
    font-weight: 700;
    color: var(--vn-secondary-color);
  }
  .summary__count__number {
    font-size: 30px;
    @include media-breakpoint-down(lg) {
      font-size: 25px;
    }
  }

}
</style>
